module.exports = __webpack_public_path__ + "static/media/logo_square.f0aa8ccc.png";